import { useEffect } from 'react';

import DatePicker from 'react-datepicker';
import { HtmlTooltip, isValidDate } from '../services/common';
import 'react-datepicker/dist/react-datepicker.css';
function DateRangePickerWithButtons({ startDate, setStartDate, endDate, setEndDate, toShow }) {
  function onChangeHandler(value) {
    setStartDate(value[0]);
    setEndDate(value[1]);
  }

  const handleCurrentMonthClick = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    setStartDate(firstDayOfMonth);
    setEndDate(today);
  };

  useEffect(() => {
    if (toShow === 'createBill') {
      handleCurrentMonthClick();
    }
  }, []);

  return (
    <HtmlTooltip
      title="Select the received date range for the document in Beiing Human"
      placement="top">
      <div>
        <DatePicker
          selectsRange={true}
          startDate={isValidDate(startDate)}
          endDate={isValidDate(endDate)}
          onChange={onChangeHandler}
          dateFormat="dd MMM yyyy"
          className={'form-control form-control-sm'}
          showDisabledMonthNavigation
          maxDate={toShow === 'filter' ? null : new Date()}
          placeholderText="Select Date Range"
          onKeyDown={(e) => {
            e.preventDefault();
          }}
        />
      </div>
    </HtmlTooltip>
  );
}
export default DateRangePickerWithButtons;
